import React from 'react';
import '../css/popup.scss';

function ReactPopup(props : any) {

  return (
    <div className='popup'>
      <div className='popupWrap'>
        <button className='close' onClick={() => { props.closePopup(false); }}>X</button>
        <button className='move' onClick={() => { window.open('https://96qudgus.github.io/react/', '_blank'); }}>GO</button>
        <h3>의류 쇼핑몰 프로젝트</h3>
        <p>
          리액트를 처음 공부하며 제작했던 프로젝트입니다. PC버전으로 제작되었습니다.
          <br/>React Native, React-Redux, Styled-Components 등이 사용됐습니다.
        </p>
        <img src={process.env.PUBLIC_URL + '/assets/img/shop-gif01.gif'} alt='캐러셀 이동 효과' />
        <p>
          케러셀을 통해 광고를 노출합니다. 
          <br/>등록제품이 많지 않아 전부 띄웠지만, 제품이 많아질 경우 케러셀 전용 저장소를 생성해,
          <br/>배너의 제목과 내용, 사진, 제품ID를 등록하여 관리자가 쉽게 배너 등록 할 수 있게끔 하면 좋을 것 같습니다.
        </p>
        <img src={process.env.PUBLIC_URL + '/assets/img/shop-gif02.gif'} alt='장바구니 등록' />
        <p>
          장바구니를 통해 편의성을 제공합니다.
          <br/>장바구니에 등록하려는 제품이 없을 경우, 장바구니에 등록이 가능하며,
          <br/>만약 장바구니에 같은 제품을 등록하려는 경우, 등록을 제한합니다.
        </p>
        <img src={process.env.PUBLIC_URL + '/assets/img/shop-gif03.gif'} alt='장바구니 수량 증가 및 삭제' />
        <p>
          장바구니에서 수량을 조절할 수 있으며, 수량은 최소 1개, 최대 100개까지 변경이 가능합니다.
          <br/>제품이 마음에 들지 않는다면 삭제할 수도 있습니다.
        </p>
        <img src={process.env.PUBLIC_URL + '/assets/img/shop-gif04.gif'} alt='자유게시판 작성 및 삭제' />
        <p>
          자유게시판 글 작성 및 삭제입니다.
          <br/>글 작성 시, 공백만 있을 경우 글 작성이 제한됩니다. 글의 앞 뒤에 있는 공백은 제거됩니다.
          <br/>기본적으로 마지막 글 번호의 다음 번호가 할당되며, 만약 게시글이 없을 경우 1번부터 시작됩니다.
        </p>
      </div>
    </div>
  )
}

function HtmlPopup(props : any) {
  return (
    <div className='popup'>
      <div className='popupWrap'>
        <button onClick={() => { props.closePopup(false); }}>X</button>
        <h3>HTML 프로젝트</h3>
        <p>
          비스톤스(주)에서 6개월간 계약직으로 일하며 작업했던 프로젝트입니다.
          삼성전자 글로벌 프로젝트는 AEM을 통해 제작되었으며, 안랩SMB는 HTML/CSS/JS을 통해 보수했습니다.
        </p>
        {/* 삼성 */}
        <div className='samsung'>
          <h4>1. Samsung Electronic Global</h4>
          <p>
            삼성전자 글로벌 홈페이지 제작에 참여했습니다.
            <br/>약 50개국의 PS, PD 페이지를 작업했습니다.
          </p>
          <button>PS 페이지 바로가기</button>
          <button>PD 페이지 바로가기</button>
        </div>
        {/* 안랩 */}
        <div className="ahnlab">
          <h4>2. Ahnlab SMB</h4>
          <p>
            안랩 SMB 유지/보수를 담당했습니다.
            <br/>간단한 폰트 크키 수정부터 라이브러리 수정 등 광범위하게 작업했습니다.
          </p>
          <button>안랩SMB 바로가기</button>
        </div>
      </div>
    </div>
  )
}

function WpPopup(props : any) {
  return (
    <div className='popup'>
      <div className='popupWrap'>
        <button onClick={(e) => { e.preventDefault(); props.closePopup(false); }}>X</button>
        <h3>Wordpress 프로젝트</h3>
      </div>
    </div>
  )
}

export {ReactPopup, HtmlPopup, WpPopup};